import React from 'react'
import Text from '../../Text'
import { $preOrder, $textPrimary } from '../../../styles/colors/semantics'
import styles from './styles.module.css'

function PreOrderTag({ show }) {
  return (
    <div
      className={[styles.tag, show ? styles.shown : styles.hidden].join(' ')}
      style={{ background: $preOrder, color: $textPrimary.dark }}
    >
      <Text type="tiny">Pre-order</Text>
    </div>
  )
}

export default PreOrderTag
